/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira-forge-custom-fields-in-issue-navigator');
	},
};
